import React from "react";
import { useAuth } from "../context/AuthContext";
import { Link } from "react-router-dom";
import { Zap } from "lucide-react";

/**
 * Tasteful ad placeholder — only rendered for free-tier users.
 * Real ad slots would swap in here. For now we render a house ad
 * that promotes the Pod Member upgrade (no external network calls,
 * so it also renders cleanly for logged-out visitors).
 */
export default function AdSlot({ compact = false }) {
    const { user } = useAuth();
    if (user && user.tier && user.tier !== "free") return null;

    return (
        <aside
            className={`brut-static bg-[#B8E1FF] rounded-xl ${compact ? "p-4" : "p-5"} flex items-center gap-3`}
            data-testid="ad-slot"
        >
            <div className="w-10 h-10 rounded-lg bg-white border-2 border-[#0A0A0A] flex items-center justify-center shrink-0">
                <Zap className="w-5 h-5" />
            </div>
            <div className="flex-1 min-w-0">
                <div className="text-[10px] font-black uppercase tracking-wider text-[#0A0A0A]/60 mb-0.5">Sponsored · House</div>
                <div className="font-black text-sm leading-tight">Ad-free browsing + see who rated you.</div>
                <div className="text-xs font-medium text-[#0A0A0A]/70">Pod Member — $4.99/mo. Cancel anytime.</div>
            </div>
            <Link
                to="/pricing"
                className="px-3 py-2 rounded-lg brut bg-[#FFE55C] font-bold text-xs shrink-0"
                data-testid="ad-slot-cta"
            >
                Upgrade
            </Link>
        </aside>
    );
}
